import React, {PureComponent} from "react";
import {SvgLoader, SvgProxy} from '../react-svgmt';
// import { SvgLoader, SvgProxy } from 'react-svgmt';

import style from "./icon.module.css"
import {changeShapesColorInNode} from "../../utils";



export const IconLabel = ({color, label}) => (
    <div className={`uppercase ${style.iconLabel} medium`}
         style={{
           color: color
         }}
    >
      {label}
    </div>
);


export class Icon extends PureComponent {

  render() {
    const {path, iconColor, css = {}, className = "", backgroundColor} = this.props;
    const selector = `svg>g`;
    return (
        <div className={`${style.icon} ${className}`}>
          <div className={style.iconWrapper} style={css}>
            <SvgLoader path={path}>
              <SvgProxy selector={selector}
                        onElementSelected={(nodes) => {
                          if(nodes.length){
                            //expect always to first group be the background
                            const background = nodes.shift();
                            changeShapesColorInNode(background, backgroundColor);
                            nodes.forEach((node, i) => {
                              if (i === this.props.currentIndex) {
                                node.classList.add("highlighted");
                                changeShapesColorInNode(node, this.props.iconColor);
                              } else {
                                node.classList.remove("highlighted");
                              }
                            })
                          }else{
                            //console.log("invalid SVG format, expect at-least two groups");
                          }
                        }}/>
            </SvgLoader>
          </div>
          {
            this.props.label &&
            <IconLabel color={iconColor} label={this.props.label}/>
          }

        </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/icon/index.js